import { render } from "./BarcodeLabels.vue?vue&type=template&id=68dbffeb"
import script from "./BarcodeLabels.vue?vue&type=script&lang=js"
export * from "./BarcodeLabels.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__